module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc176537612"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("His office on the first floor in the rear of the building had been the old nursery. The large iron fireplace, the angelic frescos, and the candle sconces all harked back to a bygone era. The oil paintings of lands afar sat uneasily with battle maps and planning boards. Incongruously, five desks surrounded a central three-way loveseat. This was the junior directing staff room, the engine room of the college—the hub that produced the college syllabus. The basic premise was to educate the annual intake of the eighty members on the real world, from politics through religion to defence. There were no “no-go” areas. It meant that anything could be discussed within the four walls of the college without any fear that opinions expressed would be reported outside, so as to provide an atmosphere of common sense and realism versus bigotry and prejudice.")]), _vm._v(" "), _c('p', {
    staticClass: "block_8",
    attrs: {
      "id": "calibre_pb_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75dd41fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_002.vue
// module id = 69
// module chunks = 0